import {
    GET_SUSPICION_DASHBOARD,
    GET_SUSPICION_DASHBOARD_FAILURE,
    GET_SUSPICION_DASHBOARD_SUCCESS,
    GET_SUSPICION_MEMBERS,
    GET_SUSPICION_MEMBERS_FAILURE,
    GET_SUSPICION_MEMBERS_SUCCESS,
} from '../../modules/constants';

const initialState = {
    isLoading: false,
    dashboardData: null,
    membersLoading: false,
    membersList: [],
};

const suspicionDashboardReducer = (state = initialState, action) => {
    switch (action.type) {
        case GET_SUSPICION_DASHBOARD:
            return { ...state, isLoading: true };
        case GET_SUSPICION_DASHBOARD_SUCCESS:
            return {
                ...state,
                isLoading: false,
                dashboardData: action.payload.data.data,
            };
        case GET_SUSPICION_DASHBOARD_FAILURE:
            return { ...state, isLoading: false, dashboardData: null };

        case GET_SUSPICION_MEMBERS:
            return { ...state, membersLoading: true, membersList: [] };
        case GET_SUSPICION_MEMBERS_SUCCESS:
            return {
                ...state,
                membersLoading: false,
                membersList: action.payload.data.data?.results || action.payload.data.data || [],
            };
        case GET_SUSPICION_MEMBERS_FAILURE:
            return { ...state, membersLoading: false, membersList: [] };

        default:
            return state;
    }
};

export default suspicionDashboardReducer;
